exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@font-face {\n  font-family: 'PuppyBellies';\n  src: url(" + require("./fonts/PuppyBellies.ttf") + ") format(\"truetype\"); }\n\n.petsitter-name {\n  font-family: 'PuppyBellies'; }\n\nh3 {\n  font-family: 'Caveat', cursive;\n  font-size: 3em; }\n\nbody {\n  font-family: 'Cabin', sans-serif;\n  font-size: 1.1em; }\n\n.flash-success,\n.flash-warning,\n.flash-error {\n  border: 1px solid #ccc;\n  border-radius: 10px;\n  display: block;\n  font-size: 1.5em;\n  padding: 20px;\n  position: fixed;\n  right: 10px;\n  text-align: center;\n  top: 110px;\n  width: 30%;\n  z-index: 100000; }\n\n.flash-success {\n  background-color: #c7f282; }\n\n.flash-warning {\n  background-color: #f1e681; }\n\n.flash-error {\n  background-color: #f08181; }\n\n.main-container {\n  min-height: 88.6vh;\n  padding-top: 100px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js!./src/App.scss
// module id = 119
// module chunks = 0